





























































import { editFactory } from '@/main/pages';

import { store } from './store/edit';
import { NAME } from './constants';
import { apiProvider } from './api';


export default editFactory(NAME, store).extend({
	data() {
		return {
			apiProvider,
		};
	},
	methods: {
		onSkOClick() {}, // TP1/TODO- Akcni tlacitko SkO
		onRezervaceClick() {}, // TP1/TODO- Akcni tlacitko Rezervace
	},
});
